import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(requestBody: Request): Promise<Optional<void>> {
	const url: string = `${SERVICEBASEURL.USER}/User/SendConfirmationcode`;
	return axios.post(url, requestBody);
}

export interface Request {
	email: string;
	confirmationPageUrl: string;
}
